import { Box, CircularProgress, Dialog, DialogContent, Grid, Switch, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { useUpdateShopConfig } from '../../../services/core/settings/settings.hooks';
import CarfaxSvg from '../../../utility/Svg/CarfaxSvg';

const styles = {
    actionLeftContent: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
    },
    carfaxImg: {
        height: '26px',
        display: 'block',
    },
};

const PublishCarfax = ({ configData }) => {
    const updateShopConfigMutation = useUpdateShopConfig();
    const serverValue = configData?.config?.carfaxSettings?.autoPublishToCarfax || false;
    const [optimisticValue, setOptimisticValue] = useState(serverValue);

    // Keep in sync if configData changes from outside
    useEffect(() => {
        setOptimisticValue(serverValue);
    }, [serverValue]);

    const handleToggle = async () => {
        const newValue = !optimisticValue;
        setOptimisticValue(newValue); // instant UI update
        try {
            const shopConfigResponse = await updateShopConfigMutation.mutateAsync({ carfaxSettings: { autoPublishToCarfax: newValue } });
            if (shopConfigResponse) {
                toast.success('Changes Saved');
            }
        } catch (error) {
            setOptimisticValue(!newValue); // revert on failure
            toast.error('Failed to save changes');
        }
    };

    return (
        <Box>
            <Grid
                container
                sx={{ boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.06)', border: '1px solid rgba(0, 0, 0, 0.10)', bgcolor: 'white' }}
                padding="24px"
                borderRadius="10px"
                marginTop="32px"
            >
                <Grid item xs={12} md={4}>
                    <Box sx={styles.actionLeftContent}>
                        <Typography variant="body1" fontSize="24px" fontWeight={400} lineHeight={'32px'}>
                            Auto Publish to
                        </Typography>
                        <CarfaxSvg />
                    </Box>
                </Grid>

                <Grid
                    item
                    xs={12}
                    md={8}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '12px',
                    }}
                >
                    <Typography variant="body1" fontSize="16px" fontWeight="400" color="rgba(0, 0, 0, 0.87)" mt={0} letterSpacing={'0.15px'}>
                        Automatically publish all new invoices to Carfax. You can always turn it off for any individual invoice.
                    </Typography>

                    <Switch checked={optimisticValue} onChange={handleToggle} disabled={updateShopConfigMutation.isPending} />
                </Grid>
            </Grid>

            <Dialog fullScreen={false} open={updateShopConfigMutation.isPending}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default PublishCarfax;
